import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import './App.css';

const products = [
  {
    id: 1,
    name: "Majengo",
    href: "/majengo",
    imageSrc: "images/majengo2.jpg",
    imageAlt: "majengo.",
  },
  {
    id: 2,
    name: "Korogocho  part 1",
    href: "/korogocho",
    imageSrc: "images/koch100.jpg",
    imageAlt: "korogocho pt1",
  },
  {
    id: 3,
    name: "Korogocho part 2",
    href: "/korogocho2",
    imageSrc: "images/koch200.jpg",
    imageAlt: "korogocho pt2",
  },
  {
    id: 4,
    name: "Kahawa West (Soweto)",
    href: "/soweto",
    imageSrc: "images/soweto.jpg",
    imageAlt: "soweto",
  },
  {
    id: 5,
    name: "Dorothy Home (Thome)",
    href: "/thome",
    imageSrc: "images/thome5.jpg",
    imageAlt: "thome",
  },
];

const Gallery = () => {
  const { page } = useParams();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Set loaded to true after a short delay to allow animations to occur
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [page]); // Re-run effect when page changes

  return (
    <div className={`pb-12 py-2 bg-orange-700 ${loaded ? 'slide-in' : ''}`}>
      <div className="mx-auto max-w-2xl px-4 py-8 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8" id="gallery">
        <h2 className="text-center text-4xl font-bold font-heading2 tracking-tight text-black">GALLERY</h2>
        <h4 className="py-2 text-center text-lg font-bold tracking-tight text-black">
          As you explore our gallery, we invite you to consider how you can join us in creating a brighter future for those in need. Together, we can make a difference.
        </h4>

        <div className="mt-6 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
          {products.map((product) => (
            <Link key={product.id} to={product.href}>
              <div className="group relative transition-transform transform hover:scale-105">
                <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md bg-gray-200 lg:aspect-none group-hover:opacity-75 lg:h-48">
                  <img src={product.imageSrc} alt={product.imageAlt} className="h-full w-full object-cover object-center lg:h-full lg:w-full" style={{ filter: "brightness(60%)" }} />
                </div>
                <div className="absolute inset-0 flex items-center justify-center sm:text-4xl">
                  <h3 className="text-white text-center font-bold font-heading text-3xl">{product.name}</h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
 
        <div className="py-6 flex items-center justify-center">
          <h1 className="font-bold text-black text-3xl text-center">Ready To Help?</h1>
        </div>

        <div className="flex items-center justify-center">
          <Link to="/events">
            <button className="px-16 bg-red-700 rounded-md py-2.5 text-white text-lg transition-transform transform hover:scale-110">See Our Event Page</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
